import { render, staticRenderFns } from "./SuccessPayment.vue?vue&type=template&id=10f6e35d&"
import script from "./SuccessPayment.vue?vue&type=script&lang=js&"
export * from "./SuccessPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports